module.exports = __webpack_public_path__ + "img/guardian_monkey.42d2017f.png";